import React from "react";

import TextField from "@material-ui/core/TextField";
import { Field, ErrorMessage } from "formik";
import InputMask from "react-input-mask";

import TextError from "./TextError";

function FormikTextField(props) {
  const { name, mask, ...rest } = props;

  return (
    <div className="form-control">
      <Field name={name}>
        {({ form, field }) => {
          const { setFieldValue } = form;
          const { value } = field;
          const handleOnChange = (e) => {
            setFieldValue(name, e.target.value);
            if (props.onChange) return props.onChange(e);
          };
          return (
            <div>
              <InputMask mask={mask} value={value} onChange={handleOnChange}>
                <TextField
                  {...rest}
                  style={{ width: "100%" }}
                  variant="outlined"
                />
              </InputMask>
            </div>
          );
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default FormikTextField;
